import React, { useCallback, useEffect } from "react";
import { Box, Typography, useMediaQuery } from "@mui/material";
import useEmblaCarousel from "embla-carousel-react";
import { motion } from "framer-motion";

const brandLogos = [
  "acer.webp",
  "toshiba.webp",
  "epson.webp",
  "asus.webp",
  "dell.webp",
  "hp.webp",
  "lenovo.webp",
  "apple.webp",
  "microsoft.webp",
  "msi.webp",
];

const BrandsCarousel = () => {
  const isMobile = useMediaQuery("(max-width: 600px)");
  const isLargeScreen = useMediaQuery("(min-width: 1920px)");
  const slidesToShow = isMobile ? 2 : 4;
  const containerWidth = isLargeScreen ? "65%" : "78%";

  const [carouselRef, embla] = useEmblaCarousel({
    loop: true,
    align: "start",
    containScroll: "trim",
    slidesToScroll: 1,
  });

  const handleAutoScroll = useCallback(() => {
    if (embla) embla.scrollNext();
  }, [embla]);

  useEffect(() => {
    const interval = setInterval(handleAutoScroll, 2000);
    return () => clearInterval(interval);
  }, [handleAutoScroll]);

  return (
    <Box
      sx={{
        py: 6,
        backgroundColor: "#ffffff",
        display: "flex",
        flexDirection: "column",
        alignItems: "center",
        textAlign: "center",
      }}
    >
      {/* Título */}
      <motion.div
        initial={{ opacity: 0, y: 20 }}
        whileInView={{ opacity: 1, y: 0 }}
        transition={{ duration: 0.6 }}
        viewport={{ once: true, amount: 0.2 }}
      >
        <Typography
          variant="h2"
          sx={{
            fontWeight: "bold",
            mb: 2,
            color: "#555",
            fontSize: { xs: "1.5rem", sm: "1.5rem", md: "1.75rem", lg: "1.8rem" },
          }}
        >
          Trabajamos con las mejores marcas
        </Typography>
      </motion.div>

      {/* Texto secundario */}
      <motion.div
        initial={{ opacity: 0, y: 20 }}
        whileInView={{ opacity: 1, y: 0 }}
        transition={{ duration: 0.6, delay: 0.2 }}
        viewport={{ once: true, amount: 0.3 }}
      >
        <Typography
          variant="body1"
          sx={{
            fontSize: { xs: "0.9rem", md: "1rem" },
            color: "#666",
            maxWidth: "640px",
            mb: 4,
            px: { xs: 2, sm: 0 },
          }}
        >
          Ofrecemos repuestos originales y de alta calidad para las marcas más reconocidas del mercado,
          con garantía y respaldo de años de experiencia en el sector tecnológico.
        </Typography>
      </motion.div>

      {/* Carrusel */}
      <Box
        ref={carouselRef}
        sx={{
          overflow: "hidden",
          maxWidth: containerWidth,
          width: "100%",
        }}
      >
        <Box
          sx={{
            display: "flex",
            gap: { xs: 3, sm: 4, md: 6 },
            px: { xs: 2, sm: 4 },
          }}
        >
          {brandLogos.map((logo, index) => (
            <Box
              key={index}
              sx={{
                flex: `0 0 calc(100% / ${slidesToShow})`,
                display: "flex",
                justifyContent: "center",
                alignItems: "center",
              }}
            >
              <motion.div
                initial={{ opacity: 0, scale: 0.9 }}
                whileInView={{ opacity: 1, scale: 1 }}
                transition={{ duration: 0.5 }}
                viewport={{ once: true, amount: 0.1 }}
              >
              <Box
                component="img"
                src={require(`../../static/media/home/marcas/${logo}`)}
                alt={logo}
                sx={{
                  maxWidth: { xs: '90px', sm: '110px', md: '130px' },
                  maxHeight: { xs: '50px', sm: '60px', md: '70px' },
                  width: 'auto',
                  height: 'auto',
                  objectFit: 'contain',
                }}
              />
              </motion.div>
            </Box>
          ))}
        </Box>
      </Box>
    </Box>
  );
};

export default BrandsCarousel;
